import React from 'react';
import {
  Header,
  Hero,
  Projects,
  About,
  Experience,
  Skills,
  
  Contact,
  Footer
} from './components';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <Header />
      <main>
        <Hero />
  
        <About />
        <Experience />
        <Projects />
        <Skills />
        
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;